import cliente_model from '@/shared/models/cliente_model';
import estado_solicitud_model from '@/shared/models/estado_solicitud_model';
import usabilidad_model from '@/shared/models/usabilidad_model';
import unidad_medida_model from '@/shared/models/unidad_medida_model';
import technical_specification_elemento_model from './technical_specification_elemento_model';
import technical_specification_producto_model from './technical_specification_producto_model';

export default {
  Codigo: null,
  CodigoEstado: null,
  FechaEstado: null,
  CodigoCliente: null,
  EsGlobal: false,
  Observaciones: null,
  Notas: null,
  ObservacionesCotizacion: null,
  Referencia: null,
  DescripcionFormula: null,
  CodigoUsabilidad: null,
  CodigoUnidadVenta: null,
  CodigoUsuarioCreacion: null,
  FechaCreacion: null,
  CodigoUsuarioActualizacion: null,
  FechaActualizacion: null,
  Estado: { ...estado_solicitud_model, Codigo: 1 },
  Cliente: { ...cliente_model },
  EspecificacionTecnicaAdjunto: [],
  EspecificacionTecnicaProducto: [{ ...technical_specification_producto_model, ItemProducto: 1 }],
  EspecificacionTecnicaElemento: [{ ...technical_specification_elemento_model, ItemElemento: 1 }],
  Usabilidad: { ...usabilidad_model },
  UnidadVenta: { ...unidad_medida_model },
};
